import React from 'react';

export default function AIProgressBar({ name, remaining, total = 13 }) {
  const pct = remaining / total;
  const color = pct > 0.6 ? '#4ade80' : pct > 0.3 ? '#facc15' : '#f87171';
  const segments = Array.from({ length: total }, (_, i) => i < (total - remaining));

  return (
    <div style={{ width: '100%', padding: '4px 0' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
        <span style={{ color: 'rgba(248,113,113,0.8)', fontSize: '0.65rem', fontWeight: '700', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
          🤖 {name}
        </span>
        <span style={{ color, fontSize: '0.65rem', fontWeight: '700' }}>
          {remaining} remaining
        </span>
      </div>
      <div style={{ display: 'flex', gap: '2px', height: '8px' }}>
        {segments.map((filled, i) => (
          <div key={i} style={{
            flex: 1,
            borderRadius: '2px',
            backgroundColor: filled ? color : 'rgba(255,255,255,0.1)',
            transition: 'background-color 0.3s ease',
          }} />
        ))}
      </div>
    </div>
  );
}
